import classNames from "classnames";
import {Product} from "@/entities/product";
import {useMainNewProductsCarousel} from "../model/hooks/useMainNewProductsCarousel";
import {CatalogCard} from "@/widgets/catalog-card";
import {Svg} from "@/shared/ui/Svg";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {Button} from "@/shared/ui/Button";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import styles from "./MainNewProductsCarousel.module.scss";

type Props = {
    products: Product[];
    link: string;
    linkName: string;
    path: string;
    mobilePath: string;
    alt: string;
}

export const MainNewProductsCarousel = ({products, link, linkName, path, mobilePath, alt}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useMainNewProductsCarousel();

    const {registerView} = useViewItemBatcher();

    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <Picture src={path} srcMobile={mobilePath} alt={alt} classes={{root: styles.picture}} />
            </div>
            <div className={styles.carousel}>
                <div className={`globalContainer`}>
                    <div ref={carouselRef} className={styles.carouselViewport}>
                        <div className={styles.carouselContainer}>
                            {products.map((product, i) => {
                                return (
                                    <CatalogCard
                                        key={product.id}
                                        product={product}
                                        className={styles.carouselSlide}
                                        index={i + 1}
                                        registerView={registerView}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
                {products.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
            <div className={`globalContainer`}>
                <Link href={link}><Button variant={`tertiary`} fullWidth>{linkName}</Button></Link>
            </div>
        </div>
    );
}
